import { render, staticRenderFns } from "./OrderStockAllocationTable.vue?vue&type=template&id=6eca1570&scoped=true&"
import script from "./OrderStockAllocationTable.vue?vue&type=script&lang=ts&"
export * from "./OrderStockAllocationTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStockAllocationTable.vue?vue&type=style&index=0&id=6eca1570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca1570",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VChip,VDataTable,VDivider,VLazy,VSpacer,VTextField})
